import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ProfileService } from '../../../pages/profile.service';
import { Router } from '@angular/router';

declare const google: any;          // 🟢 ให้ TS รู้จักตัวแปร global

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = '../assets/img/users/user.jpg';
  constructor(
    private profileService: ProfileService,
    public router:Router, 
  ) { }

  private ggData: any;
  private userName = "";
  private email = "";

  ngOnInit() {

    this.ggData     = this.profileService.getLSGG();

    if( this.ggData ){
      // this.userImage  = <string> this.ggData["image"];
      // this.userName   = <string>this.ggData["name"];
      this.email      = <string>this.ggData["email"];
    }
  }

  logout() {
    this.profileService.removeProfile(); // clear session
    // google.accounts.id.disableAutoSelect(); // reset GIS selection
    this.router.navigate(['/login']);
  }

}
